import React, { useEffect, useState } from 'react'
import {
  Table,
  Input,
  Select,
  Button,
  Space,
  Card,
  Row,
  Col,
  Switch,
  message,
  Modal,
  Popconfirm,
} from 'antd'
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import styles from './PointsRechargeRatioManage.module.css'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

import { Pagination } from 'antd'

import CommonModal from './add/Common.js'
import EditCommonModal from './edit/Common.js'

import {
  getGuangdongnengListRequest,
  delPointRequest,
  shouquanPointRequest
} from './api'
import { closeAdminPage, openLogin } from '../../../store/modalsSlice'
import settingIcon from './setting.svg'
import { useDispatch } from 'react-redux'
import { clearAllCookies } from '../../../util/handleObject.js'
import InfoItem from './InfoItem.jsx'
const { Option } = Select

const PointManagement = () => {
  const dispatch = useDispatch()
  const [listData, setListData] = useState([])
  // 分页状态

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isShowEditCommon, setIsShowEditCommon] = useState(false)
  const [editPoint, setEditPoint] = useState(null)


  useEffect(() => {
    getPointList()
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getPointList() {
    getGuangdongnengListRequest((data) => {
      if (data.ret === '1') {
        setListData(data.data)
      } else {
        setListData([])
      }
    })
  }

  function deletePoint(id) {
    delPointRequest(id, (data) => {
      console.log(data)
      if (data.ret === '1') {
        message.success('删除成功', 1)
        getPointList()
      } else {
      }
    })
  }

  function closeCommonModal() {
    setIsModalVisible(false)
    setIsShowEditCommon(false)
  }

  function updateData() {
    getPointList()
  }
  function updateStatus(info, checked) {
    shouquanPointRequest(checked ? '1' : '2', info.Id, (data) => {
      console.log(data)
      if (data.ret === '1') {
        message.success('状态更改成功', 1)
        getPointList()
      } else {
        message.error('状态更改失败', 1)
      }
    })
  }

  // 处理删除操作
  const handleDelete = (info) => {
    console.log(info)
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除金额为' + info.jiage + '数据吗？删除后不可恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        console.log('用户点击了确定')
        // 在这里调用删除API
        deletePoint(info.Id)
      },
      onCancel() {
        console.log('用户点击了取消')
      },
    })
  }
  const handleEdit = (point) => {
    setEditPoint(point)
    setIsShowEditCommon(true)
  }

  return (
    <div className={styles.background}>
      <div className={styles.rightMenus}>
        <div className={styles['div-top']}>
          <h3 style={{ marginLeft: 30 }}>积分充值管理</h3>
          <Popconfirm
            placement="bottom"
            title={''}
            description={'是否退出登录'}
            okText="是"
            cancelText="否"
            onConfirm={(e) => {
              sessionStorage.clear()
              clearAllCookies()
              dispatch(closeAdminPage())
              dispatch(openLogin())
            }}
          >
            <div className={styles.iconContainer}>
              <img
                src={settingIcon}
                style={{ width: '20px', height: '20px' }}
              />
            </div>
          </Popconfirm>

          <Button
            className={styles['bt-refresh']}
            type="primary"
            onClick={(e) => {
              getPointList()
            }}
          >
            刷新
          </Button>
        </div>

        <Card title="" className={styles['card-bottom']}>
          <div className={styles['container-list']}>
            <div className={styles['div-shaixuan']}>
              <div>数据列表</div>

              <Button
                style={{ marginLeft: 'auto' }}
                type="primary"
                onClick={() => {
                  setIsModalVisible(true)
                }}
              >
                添加
              </Button>
            </div>

            <div style={{ marginTop: 10 }}>
              <table className={styles.infoTable}>
                <tr className={styles.tr1}>
                  <td className={styles.td1}>充值金额</td>
                  <td className={styles.td2}>赠送积分</td>
                  <td className={styles.td2}>实际到账积分</td>
                  <td className={styles.td2}>状态</td>
                  <td className={styles.td2}>操作时间</td>
                  <td className={styles.td2}>操作</td>
                </tr>
                {listData.map((item, index) => (
                  <InfoItem
                    item={item}
                    key={index + 1}
                    index={index + 1}
                    editMethod={(info) => {
                      handleEdit(info)
                    }}
                    deleteMethod={(info) => {
                      handleDelete(info)
                    }}
                    updateStatus={(info, checked) => {
                      updateStatus(info, checked)
                    }}
                  />
                ))}
              </table>
            </div>
          </div>
        </Card>
      </div>

      <CommonModal
        updateData={(e) => {
          getPointList()
        }}
        openStatus={isModalVisible}
        closeCommonModal={closeCommonModal}
      />

      <EditCommonModal
        openStatus={isShowEditCommon}
        info={editPoint}
        updateData={updateData}
        closeCommonModal={closeCommonModal}
      />
    </div>
  )
}

export default PointManagement

